
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoindoreinnovacabinnova() {



    const cardData =
    {
        keyword: 'Pune to Indore Innova Crysta Cabs Booking',
        heading: 'Meghana Cab : Pune to Indore Innova Crysta Cabs Booking',
        headingDescription: 'Meghana Cab offers Pune to Indore Innova Crysta Cabs Booking, providing a comfortable, spacious, and reliable travel experience for families, groups, and business travelers heading to the vibrant city of Indore. With plush leather seating, ample legroom, air-conditioning, and generous luggage space, our Innova Crysta vehicles are perfectly suited for long-distance travel. Whether you are planning a religious visit, a corporate trip, or a family getaway, Meghana Cab ensures a smooth and safe journey with professional chauffeurs, door-to-door pickup from anywhere in Pune, and flexible booking options. Enjoy a seamless travel experience with 24/7 customer support, GPS-enabled vehicles, and a commitment to punctual, high-quality service from start to finish. Book your Pune to Indore Innova Crysta Cab with Meghana Cab and experience road travel at its best.',


        top: 'Top Places to Visit in Indore with Meghana Cab',

"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "The seven‑storied Holkar-era Rajwada Palace (built mid‑18th century) blends Maratha, Mughal, and French architecture. Located near bustling Chhatris, it now hosts an evening light‑and‑sound show narrated in Hindi and English. The restored grounds include fountains, gardens, and a statue of Maharani Ahilyabai Holkar, making it a cultural centerpiece of Indore." 
  },
  {
    "title": "Lal Bagh Palace",
    "description": "An opulent Italian Renaissance Revival mansion built in the late 19th–early 20th century by the Holkars. Spread across 76 acres, it features grand ballrooms, chandeliers, Persian carpets, and regal furnishings. Meticulous restoration in recent years has revived its original elegance, offering visitors a glimpse into royal grandeur." 
  },
  {
    "title": "Sarafa Bazaar",
    "description": "A unique double‑life marketplace in the heart of Indore—retail jewellery by day and a vibrant street‑food court by night. With over 190 vendors, Sarafa serves everything from chaat and kulfi to regional sweets. It's a foodie pilgrimage that embodies Indore’s reputation as India’s cleanest city." 
  },
  {
    "title": "Chappan Dukan",
    "description": "Literally ‘56 Shops’, this famed food street in Palasia packs 56 stalls offering local snacks, sweets, and quick bites. From samosas and idlis to milkshakes and chaats, it’s a must‑visit for street‑food lovers exploring Indore’s culinary scene." 
  },
  {
    "title": "Khajrana Ganesh Temple",
    "description": "A prominent temple built by Ahilyabai Holkar’s regime to protect a divine Ganesh idol from Aurangzeb. Devotees throng here year‑round, especially during Ganesh Chaturthi. The serene temple complex offers a spiritual retreat amidst city life." 
  },
  {
    "title": "Annapurna Temple",
    "description": "A grand temple complex dedicated to Goddess Annapurna, the patron deity of nourishment. With distinctive spires and ornate carvings, the temple also houses shrines for Shiva, Hanuman, and Kalabhairava. It is especially lively during Navratri." 
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "Established in 1929, this museum showcases archaeological and historical artefacts—from prehistoric relics and stone sculptures to coins and weaponry from Mughal and Holkar eras. It’s a treasure trove for history enthusiasts." 
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Once the Holkars’ royal hunting grounds, this 5 km² forest sanctuary is now a protected area featuring deer, leopards, rabbits, and birdlife. The former royal hunting lodge (Holkar palace) stands amid walking trails—a peaceful urban nature escape." 
  },
  {
    "title": "Patalpani Waterfall",
    "description": "About 35 km from the city, Patalpani is a 300‑ft scenic waterfall that swells dramatically during monsoon. It’s a popular picnic and trekking spot, surrounded by lush Vindhya hills—but visitors should exercise caution during peak rains." 
  },
  {
    "title": "Choral Dam & Pipliyapala Regional Park",
    "description": "Choral Dam lies within the scenic Pipliyapala Recreational Park, combining lakeside gardens, walkways, boating facilities, and an open‑air theatre. It’s a favourite with families and evening strollers." 
  }
],

     "services": [
    {
      "name": "Pune to Indore Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Indore for a smooth and luxurious long-distance ride. Our cabs come with experienced chauffeurs, spacious interiors, and amenities for a hassle-free journey across the 600+ km route."
    },
    {
      "name": "One Way Innova Crysta Pune Indore",
      "description": "Opt for our one-way Innova Crysta service from Pune to Indore for convenient intercity travel. Ideal for airport drops, business visits, or family travel—this package includes tolls, driver charges, and fuel in a fixed fare."
    },
    {
      "name": "Round Trip Innova Crysta Pune Indore",
      "description": "Plan a round trip from Pune to Indore and back with our Innova Crysta service. Enjoy flexible return schedules, discounted round-trip pricing, and a reliable chauffeur available throughout your journey."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Indore",
      "description": "Beat the heat during long hours on the road with our fully air-conditioned Innova Crysta taxi. Equipped with rear AC vents, adjustable seating, and smooth suspension, this vehicle is perfect for long journeys like Pune to Indore."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Indore",
      "description": "Sit back and relax while our professional chauffeurs drive you from Pune to Indore in style. All drivers are background-verified, trained for highway routes, and committed to providing courteous service with utmost safety."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Indore",
      "description": "Enjoy exclusive private cab service in a clean and spacious Innova Crysta from Pune to Indore. No ride-sharing—just you, your group, and the open highway with complete privacy and comfort."
    },
    {
      "name": "Online Booking Innova Crysta Pune Indore",
      "description": "Book your Pune to Indore Innova Crysta cab online with instant confirmation. Our platform offers real-time availability, multiple payment options, and transparent pricing—ensuring a seamless digital booking experience."
    },
    {
      "name": "Indore Airport Transfer Innova Crysta",
      "description": "Get reliable airport transfers from Pune to Indore’s Devi Ahilya Bai Holkar Airport in a well-maintained Innova Crysta. We ensure timely drop-offs or pickups with live tracking and 24x7 availability."
    },
    {
      "name": "Business Trip Innova Crysta Pune Indore",
      "description": "Traveling for business? Our executive-grade Innova Crysta rentals offer ample workspace, Wi-Fi (on request), and punctual service to help you stay productive on the move between Pune and Indore."
    },
    {
      "name": "Family Travel Innova Crysta Indore",
      "description": "Make family road trips from Pune to Indore fun and relaxing. Our 6- or 7-seater Innova Crysta cabs come with child-friendly seating, luggage space, and comfort stops tailored to your travel needs."
    },
    {
      "name": "Affordable Innova Crysta Taxi Pune Indore",
      "description": "Looking for value without compromising on comfort? Our budget-friendly Innova Crysta cab options from Pune to Indore come with transparent fare structures, discounts on advance bookings, and group packages."
    },
    {
      "name": "Long Route Innova Crysta Pune Indore",
      "description": "Choose Innova Crysta for long routes like Pune to Indore, offering unmatched comfort for 10+ hour drives. Features like adjustable reclining seats, charging ports, and experienced highway drivers make every km enjoyable."
    },
    {
      "name": "Reliable Innova Crysta Taxi Indore",
      "description": "Depend on our reliable Innova Crysta fleet for your Pune to Indore travel. With 24/7 support, vehicle tracking, and professionally maintained cabs, your ride will always be smooth, safe, and on time."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Indore",
      "description": "Enjoy long-distance comfort in our premium Innova Crysta cab from Pune to Indore. From extra legroom and clean upholstery to quiet interiors and courteous chauffeurs, we prioritize your travel comfort."
    },
    {
      "name": "Premium Innova Crysta Rental Pune Indore",
      "description": "Upgrade your road trip with our premium Innova Crysta rental from Pune to Indore. Ideal for VIP guests, executives, or families looking for a luxurious road experience with all modern conveniences and safety features."
    }
  ],
  "tableData": [
    ["Pune to Indore Innova Crysta Cab Booking", "One Way Innova Crysta Pune Indore"],
    ["Round Trip Innova Crysta Pune Indore", "AC Innova Crysta Taxi Pune Indore"],
    ["Chauffeur Driven Innova Crysta Pune Indore", "Private Innova Crysta Taxi Pune Indore"],
    ["Online Booking Innova Crysta Pune Indore", "Indore Airport Transfer Innova Crysta"],
    ["Business Trip Innova Crysta Pune Indore", "Family Travel Innova Crysta Indore"],
    ["Affordable Innova Crysta Taxi Pune Indore", "Long Route Innova Crysta Pune Indore"],
    ["Reliable Innova Crysta Taxi Indore", "Comfortable Innova Crysta Cab Pune Indore"],
    ["Premium Innova Crysta Rental Pune Indore", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Innova Crysta Cabs from Pune to Indore",
    "WhyChoosedescription": "Book our Innova Crysta cab for a smooth and relaxing road journey from Pune to Indore, covering approximately 600+ km. Whether you're traveling for business, studies, or a family visit, we offer comfort, reliability, and a premium travel experience."
  },
  {
    "WhyChooseheading": "Spacious Interiors for Long-Distance Comfort",
    "WhyChoosedescription": "Our Innova Crysta vehicles feature reclining seats, dual AC, and generous legroom, perfect for long trips. The vehicle accommodates up to 6–7 passengers along with ample luggage space, making it ideal for families or small groups."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Inter-State Travel",
    "WhyChoosedescription": "Our chauffeurs are skilled in long-distance driving and well-versed with the Pune–Indore highway routes. They ensure a smooth and timely ride while prioritizing safety, comfort, and regular breaks when needed."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "We follow a strict cleaning and sanitization routine before every ride. Our Innova Crystas are regularly serviced and maintained to ensure your journey is both comfortable and worry-free, especially for multi-hour drives."
  },
  {
    "WhyChooseheading": "One-Way, Round Trip & Multi-Day Booking Options",
    "WhyChoosedescription": "Whether you need a one-way drop to Indore, a return plan, or a multi-day outstation rental, we provide flexible cab booking options to suit your schedule. Perfect for short stays or extended travel plans."
  },
  {
    "WhyChooseheading": "All-Inclusive and Transparent Taxi Fare",
    "WhyChoosedescription": "Our pricing includes tolls, fuel, driver allowance, and inter-state taxes. You get a clear, upfront fare with no hidden charges—making your Pune to Indore trip stress-free and budget-friendly."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Student, and Family Travel",
    "WhyChoosedescription": "Innova Crysta is a preferred choice for long-distance travel to Indore—be it corporate mobility, student relocation, or a family trip. Enjoy premium comfort, reliable service, and extra luggage space to carry everything you need."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Real-Time Updates",
    "WhyChoosedescription": "Our support team is available 24/7 to assist with bookings, travel modifications, or urgent needs. We also provide driver and vehicle details in advance for a secure, hassle-free journey."
  }
]















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Pune to Indore?",
        answer: "You can book your cab easily by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What is the distance and travel time from Pune to Indore?",
        answer: "The distance is approximately 600 km, and the travel time is around 10 to 12 hours depending on road and traffic conditions."
    },
    {
        question: "Is Innova Crysta a good choice for a long trip like Pune to Indore?",
        answer: "Yes, Innova Crysta is spacious, comfortable, and ideal for long-distance travel."
    },
    {
        question: "Can I book the cab for a one-way or round trip to Indore?",
        answer: "Yes, we offer both one-way and round-trip bookings as per your travel needs."
    },
    {
        question: "How many people can travel in an Innova Crysta?",
        answer: "The vehicle can accommodate 6 to 7 passengers with luggage comfortably."
    },
    {
        question: "Are Meghana Cab vehicles sanitized before each trip?",
        answer: "Yes, all our cabs are properly sanitized before every journey to ensure passenger safety."
    },
    {
        question: "Are your drivers experienced in long-distance intercity routes?",
        answer: "Absolutely. Our drivers are well-trained, experienced, and familiar with the Pune to Indore route."
    },
    {
        question: "What is included in the Pune to Indore cab fare?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional charges may apply for parking or extra stops."
    },
    {
        question: "Is it possible to request meal or rest stops during the journey?",
        answer: "Yes, scheduled stops can be arranged upon request during your booking."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Arvind Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Indore trip in the Innova Crysta was extremely comfortable. The car was clean and the service was top-notch.”',
    },
    {
        name: 'Ms. Nidhi Verma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for my family to Indore. Great ride, polite driver, and timely service.”',
    },
];


























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneToIndoreInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Indore Innova Crysta Cabs Booking",
  "description": "Book AC Innova Crysta taxi service from Pune to Indore for one way, round trip, business trips, family travel, and airport transfers. Reliable, comfortable, and affordable chauffeur-driven service.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Indore"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-indore-innova-crysta-cab-booking"
  }
};








    return (
        <div>
<Helmet>
  <title>Pune to Indore Innova Crysta Cab Booking | Reliable Taxi Service</title>
  <meta
    name="description"
    content="Book AC Innova Crysta cab from Pune to Indore for business, family trips, airport transfers, and round trips. Comfortable and affordable chauffeur-driven taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Indore Innova Crysta Cab Booking, One Way Innova Crysta Pune Indore, Round Trip Innova Crysta Pune Indore, AC Innova Crysta Taxi Pune Indore, Chauffeur Driven Innova Crysta Pune Indore, Private Innova Crysta Taxi Pune Indore, Online Booking Innova Crysta Pune Indore, Indore Airport Transfer Innova Crysta, Business Trip Innova Crysta Pune Indore, Family Travel Innova Crysta Indore, Affordable Innova Crysta Taxi Pune Indore, Long Route Innova Crysta Pune Indore, Reliable Innova Crysta Taxi Indore, Comfortable Innova Crysta Cab Pune Indore, Premium Innova Crysta Rental Pune Indore"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToIndoreInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoindoreinnovacabinnova;